import { ChangeDetectorRef, Component, NgZone, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { getAccountState, getAgentState, getCustomerConfigState } from '../../../redux/reducers';
import { AgentState } from '../../../redux/models/loyalty/agent.state';
import { Customer, customerConfig } from '@uxdf/direct-shared-lib';
import { AccountState } from '../../../redux/models/loyalty/account.state';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-loyalty-program-enrollment',
  templateUrl: './loyalty-program-enrollment.component.html',
  styleUrls: ['./loyalty-program-enrollment.component.scss']
})
export class LoyaltyProgramEnrollmentComponent implements OnInit, OnDestroy {
  // @loyaltyDocs: loyalty-program-enrollment component
  // By a set of parameters, the component determines which page should be displayed to the user:
  // - Registration request
  // - Confirmation of registration
  // - Login page

  contactId = '';

  agentState: AgentState = {
    isLoading: false,
    isAlreadyGetNumber: false,
    code: 0,
    data: {
      requestId: '',
      token: '',
      key: '',
      number: 0
    },
    message: '',
    loadingError: ''
  };
  agentAccountState: AccountState = {
    agentNumber: 0,
    isLoading: false,
    loadingError: ''
  };
  isAccountEnabled = false;
  customerConfigState: {
    customerConfig: Customer;
    isLoading: boolean;
  } = {
    customerConfig: {} as Customer,
    isLoading: false
  };

  displayView = 'enrollment';
  isSnow = false;
  private customerConfigSubscription?: Subscription;

  private readonly destroy$ = new Subject();
  private isDestroyed = false;

  constructor(
    private readonly store: Store<any>,
    private readonly route: ActivatedRoute,
    private readonly ngZone: NgZone,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    // GetAccount() is already dispatched by the login pipeline; dispatching it again here
    // races with those calls (switchMap cancels the loser) and can stall agentAccountState.isLoading.
    this.store
      .pipe(select(getCustomerConfigState), takeUntil(this.destroy$))
      .subscribe((response: { customerConfig: Customer; isLoading: boolean }) => {
        this.customerConfigState = response;
        this.refreshView();
      });

    this.store.pipe(select(getAgentState), takeUntil(this.destroy$)).subscribe((response: AgentState) => {
      this.agentState = response;
      if (response.data && response.data.number !== 0 && !response.isAlreadyGetNumber) {
        this.showLayout('finishForm');
        window.parent.postMessage('PLUSME_REGISTRATION_SUCCESS', '*');
      }
      this.refreshView();
    });

    this.store.pipe(select(getAccountState), takeUntil(this.destroy$)).subscribe((response: AccountState) => {
      this.agentAccountState = response;
      if (+(response.agentNumber || 0) !== 0) {
        this.isAccountEnabled = true;
      }
      this.refreshView();
    });

    this.processingQueryParams();

    this.customerConfigSubscription = this.store.pipe(select(customerConfig)).subscribe(response => {
      this.isSnow = response.customerConfig.is_snow;
      this.refreshView();
    });
  }

  showLayout(layout: string) {
    this.displayView = layout;
  }

  private refreshView() {
    setTimeout(() => {
      if (!this.isDestroyed) {
        this.ngZone.run(() => this.changeDetectorRef.detectChanges());
      }
    }, 0);
  }

  processingQueryParams() {
    this.route.queryParams.pipe(takeUntil(this.destroy$)).subscribe(params => {
      if (params && params.displayView) {
        const availableView = ['finishForm', 'enrollment', 'loginForm'];
        if (availableView.includes(params.displayView)) {
          this.showLayout(params.displayView);
        }
      }
    });
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    this.destroy$.next(true);
    this.destroy$.complete();
    if (this.customerConfigSubscription) {
      this.customerConfigSubscription.unsubscribe();
    }
  }
}
